export enum ETipoNotificacaoEmail {
    Padrao = 1,
    NovaReserva = 2,
    ReservaConfirmada = 3,
    ReservaCancelada = 4,
}
